import axios from "axios";
import api from "../axiosInstance";

export const updateProfileAPI = async (payload) => {
  try {
    const response = await api.put(
      process.env.REACT_APP_API_URL + "/api/v1/admin/profile",
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error : " + e.message);
    return e.message;
  }
};

// post API
export const updateImageS3 = async (imageFile) => {
  try {
    const formData = new FormData();
    formData.append("file", imageFile);
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/api/v1/s3`,
      formData,
      {
        headers: {
          "Content-type": "multipart/form-data",
          Accept: "multipart/form-data",
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("tykoon_access")),
        },
      }
    );
    return response.data;
  } catch (e) {
    console.log("updateImageS3 ", e.message);
  }
};

// Change password API
export const changePasswordAPI = async (payload) => {
  try {
    const response = await api.post(
      process.env.REACT_APP_API_URL + "/api/v1/admin/auth/change-password",
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error : " + e.message);
    throw e;
  }
};
